// The free tools, one controller per calculator or converter. Identifiers
// match FreeTools::Catalogue::Tool#controller: free-tools--<key>. Bundled
// by app/javascript/free_tools.js, which only their pages include.
import BreakEvenController from "./break_even_controller"
import ColorConverterController from "./color_converter_controller"
import CustomerLifetimeValueController from "./customer_lifetime_value_controller"
import EquityDilutionController from "./equity_dilution_controller"
import FreelanceRateController from "./freelance_rate_controller"
import KeywordDensityController from "./keyword_density_controller"
import MarkdownToHtmlController from "./markdown_to_html_controller"
import PasswordStrengthController from "./password_strength_controller"
import PomodoroController from "./pomodoro_controller"
import ProfitMarginController from "./profit_margin_controller"
import ReadingTimeController from "./reading_time_controller"
import SaasPricingController from "./saas_pricing_controller"
import TimeZoneController from "./time_zone_controller"
import UtmBuilderController from "./utm_builder_controller"

export function register(application) {
  application.register("free-tools--break-even", BreakEvenController)
  application.register("free-tools--color-converter", ColorConverterController)
  application.register("free-tools--customer-lifetime-value", CustomerLifetimeValueController)
  application.register("free-tools--equity-dilution", EquityDilutionController)
  application.register("free-tools--freelance-rate", FreelanceRateController)
  application.register("free-tools--keyword-density", KeywordDensityController)
  application.register("free-tools--markdown-to-html", MarkdownToHtmlController)
  application.register("free-tools--password-strength", PasswordStrengthController)
  application.register("free-tools--pomodoro", PomodoroController)
  application.register("free-tools--profit-margin", ProfitMarginController)
  application.register("free-tools--reading-time", ReadingTimeController)
  application.register("free-tools--saas-pricing", SaasPricingController)
  application.register("free-tools--time-zone", TimeZoneController)
  application.register("free-tools--utm-builder", UtmBuilderController)
}
